module.exports = __webpack_public_path__ + "856d2046be7161d6329fde8d73967dfd.twig";